import { api } from '@/api/core';

/** BE column filter options endpoint. Wire it up in `useAerialCaseListFilterOptions` once the API exists. */
export const AERIAL_CASE_LIST_FILTER_OPTIONS_URL = '/aerial/run/filter-options';

export type AerialCaseListFilterOptionsByColumn = Record<string, string[]>;

export interface GetAerialCaseListFilterOptionsRequest {
  aerialId: string;
  runId: string;
}

export interface GetAerialCaseListFilterOptionsResponse {
  filterOptionsByColumn: AerialCaseListFilterOptionsByColumn;
}

const getAerialCaseListFilterOptionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAerialCaseListFilterOptions: builder.query<
      GetAerialCaseListFilterOptionsResponse,
      GetAerialCaseListFilterOptionsRequest
    >({
      query: ({ aerialId, runId }) => ({
        url: AERIAL_CASE_LIST_FILTER_OPTIONS_URL,
        method: 'GET',
        params: {
          aerial_id: aerialId,
          run_id: runId,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useGetAerialCaseListFilterOptionsQuery } = getAerialCaseListFilterOptionsApi;
